<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Tạo Affiliate</span>
            <button mat-icon-button (click)="onCancel()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-24 pb-0 m-0">
        <form [formGroup]="form" class="create-affiliate-container" fxLayout="column" fxLayoutAlign="start center"
            fxLayoutGap="8px">
            <div>
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Referral Code</mat-label>
                    <input matInput name="code" formControlName="code" maxlength="8" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Họ Tên</mat-label>
                    <input matInput name="fullName" formControlName="fullName" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Danh xưng</mat-label>
                    <mat-select name="gender" formControlName="gender">
                        <mat-option class="option" value="MALE">Anh</mat-option>
                        <mat-option class="option" value="FEMALE">Chị</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Số điện thoại</mat-label>
                    <input matInput name="phone" formControlName="phone" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Email</mat-label>
                    <input matInput name="email" formControlName="email" />
                </mat-form-field>
            </div>

        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <!-- <button mat-raised-button color="primary" (click)="onCancel()">
            Cancel
        </button> -->
        <button mat-raised-button color="accent" (click)="onSubmit()">
            Tạo Code
        </button>
    </div>
</div>